import radioService from '@/services/radioService';

let Stations;
if (process.env.VUE_APP_STATIONS_VERSION === 'parc') {
  Stations = require('@/components/stations.parc.json');
} else {
  Stations = require('@/components/stations.json');
}

export default {
  namespaced: true,
  state: {
    currentStation: {
      details: null,
      muted: false,
      volume: 1,
    },
    isPlaying: false,
    isLoading: false,
    stations: Stations.stations,
    region: '',
    regions: ['uk', 'au']
  },
  getters: {},
  mutations: {
    SET_CURRENT_STATION_DETAILS(state, value) {
      state.currentStation.details = value;
      state.currentStation.muted = false;
    },
    SET_CURRENT_STATION_MUTED(state, value) {
      state.currentStation.muted = value;
    },
    SET_CURRENT_STATION_VOLUME(state, value) {
      state.currentStation.volume = Math.max(0, Math.min(1, value));
    },
    SET_IS_PLAYING(state, value) {
      state.isPlaying = value;
    },
    SET_IS_LOADING(state, value) {
      state.isLoading = value;
    },
    SET_REGION(state, value) {
      state.region = value;
    },
    SET_STATIONS(state, value) {
      state.stations = value;
    }
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    toggleFavourite({ commit }, station) {
      commit('SET_FAVOURITES_FROM_LOCAL', true);
    },
    // eslint-disable-next-line no-unused-vars
    sendLog({state, rootState}, log) {
      radioService.sendStat(log.meta || {}, log.description, rootState.isElectron);
    },
    changeRegion({commit, state}, region) {
      if(state.regions.includes(region)) {
        commit('SET_REGION', region);

        const Filtered = Stations.stations.filter(item => {
          return item.region === region;
        });

        commit('SET_STATIONS', Filtered.length > 0 ? Filtered : Stations.stations);
      }
    }
  }
};